module.exports = __webpack_public_path__ + "img/banner-1-m.fc13a88d.jpg";